import React, { useEffect, useState } from 'react'
import { useDispatch,useSelector } from 'react-redux'
import Flex from 'components/Flex'
import Button from 'components/Button'
import Avatar from 'components/Avatar'
import { Divider, Row, Col } from 'antd'
import {
  StyledDrawer,
  FooterFlex,
  Name1,
  Address,
  NameAdd,
  DetailHeader,
  LeftText,
  RightText,
} from 'modules/Roles/Style/style'
import { formatNumber } from 'utils/formatNumber'
import moment from 'moment'
import { useNavigate } from 'react-router-dom'
import { getAppliedRoleMetrics } from '../../Applied_Roles/actions'


const OfferDetailDrawer = ({
  drawer,
  setDrawer,
  setDrawerReject,
  selectedoffer,
  OfferAcceptReject,
  getUserCorpList,
  offerAccpectTemplate,
  offerRejectTemplate,
  sendNotificationBulkEmail,
  setDrawerNegotiate,
  sendInAppNotification,
  getOfferList
}) => {
  const navigate  = new useNavigate()
  const instituteName = useSelector(state => state?.studentData?.campusDetails)
  let stdData = useSelector(state => state?.studentData?.studentDetails)
  const [corporateEmailList, setCorporateEmailList] = useState([])
  useEffect(() => {
    ;(async () => {
      if (selectedoffer?.role?.corporate?.id) {
        let responce = await getUserCorpList(selectedoffer?.role?.corporate?.id)
        setCorporateEmailList(responce)
      }
    })()

    return () => {
      // this now gets called when the component unmounts
    }
  }, [selectedoffer])

  const dispatch = new useDispatch()



  const checkJobTypeLevel = (data, YOE) => {
    const transformedData = data?.map(item => {
      switch (item) {
        case 'ENTRY':
          return ' Entry Level'
        case 'INTERN':
          return ' Internship'
        case 'EXPERIENCED':
          return YOE?.length > 0 ?` ${YOE[0]} - ${YOE[1]} Yrs Experience ` :` 0 - 1 Yrs Experience `
        default:
          return item
      }
    })

    return transformedData?.toString()
  }

  const [listData, setListData] = useState([])
  useEffect(() => {
    let otherData = [
      {
        id: 1,
        name: 'Salary',
        value: `₹ ${formatNumber(selectedoffer?.salary)} ${
          selectedoffer.frequecy === 'ANNUALLY' ? ` per annum` : ` per month`
        }`,
      },
      {
        id: 2,
        name: 'Job Type',
        value: `${checkJobTypeLevel(
          selectedoffer?.role?.jobTypeLevels,
          selectedoffer?.role?.yearOfExperience
        )} (${
          selectedoffer?.role?.jobType === 'FULL_TIME'
            ? 'Full Time'
            : 'Part Time'
        })`,
      },
      {
        id: 3,
        name: 'Location',
        value: `${selectedoffer?.jobLocation}`,
      },
      {
        id:4,
        name:'Offer Received on',
        value:`${moment(selectedoffer?.createdAt)?.format('DD/MM/YYYY') }`
      },
      {
        id: 5,
        name: 'Offer Valid',
        value: `${moment(selectedoffer?.offerExpireDate)?.format(
          'DD/MM/YYYY'
        )}`,
      },
    ]
    setListData(otherData)
  }, [])

  const CheckIcons = logo => {
    if (logo === null) {
      return (
        <Avatar
          background
          size={42}
          IconName={selectedoffer?.role?.corporate?.name[0]}
          font={18}
        />
      )
    } else {
      return <Avatar size={42} src={logo} />
    }
  }

 
  
   
  const accpectOffer = () => {
    if(!stdData?.isExpCandidate)
    {
    OfferAcceptReject(selectedoffer, true)
     
    let InAppObj = 
    {
      notification: {
        students: [
          {
          ids: [stdData?.id],
      userIds: [],
      roles: ["Student"],
      issuer: "corporate",
      createFor: "student",
      inApp: true,
      body: `Congratulations! You've accepted the offer for the ${selectedoffer?.role?.tittle} position at ${selectedoffer?.role?.corporate?.name}`,
      tag: "Offer",
      }] 
    }
  }
  sendInAppNotification(InAppObj)
  let name = stdData?.admin?.first_name + ' ' + stdData?.admin?.last_name
    const final = corporateEmailList?.list?.map(item => {
      const currentDate = moment().format('DD MMM YYYY')
      const template = offerAccpectTemplate?.templateText
        ?.replace('{corporateName}', selectedoffer?.role?.corporate?.name)
        ?.replace('{instituteName}', instituteName?.campusName)
        ?.replace('{studentName}', name)
        ?.replace('{studentName}', name)
        ?.replace('{roleName}', selectedoffer?.role?.tittle)
        ?.replace('{dd/mmm/yyyy}', currentDate)
      return {
        to: item?.email,
        subject:
        offerAccpectTemplate?.subject ||
          'Drive Scheduled Notification - Pluginlive',
        htmlBody: template,
      }
    })
    sendNotificationBulkEmail(final)
    setDrawer(false)
    dispatch(getAppliedRoleMetrics())
    // getOfferList()
  }
   else{
      navigate(`/offerReceived/ExCand/${selectedoffer?.id}`)
      dispatch(getAppliedRoleMetrics())
    }
  }

  const content = () => {
    return (
      <>
        <Flex centerVertically>
          {CheckIcons(selectedoffer?.role?.corporate?.logo)}
          <NameAdd column flexStart>
            <Address>{selectedoffer?.role?.corporate?.name}</Address>
            <Name1>{selectedoffer?.role?.tittle}</Name1>
          </NameAdd>
        </Flex>

        <Divider />
        <DetailHeader>Details</DetailHeader>
        {listData?.map((item, index) => (
          <Row key={index+"list"} style={{ width: '100%' }}>
            <Col span={12}>
              <LeftText>{item.name}</LeftText>
            </Col>
            <Col span={12}>
              <RightText>{item.value}</RightText>
            </Col>
          </Row>
        ))}
      </>
    )
  }
  const footer = () => {
    return (
      <FooterFlex right>
        <Button.DangerStyle
          text="Decline"
          onClick={() => {
            setDrawerReject(true)
            setDrawer(false)
          }}
        />
        {stdData?.isExpCandidate &&
         <Button.SuccessText
          text="Negotiate"
          onClick={() => {
            setDrawerNegotiate(true)
            setDrawer(false)
          }}
        />
        }
        <Button.Primary htmlType="submit" onClick={accpectOffer} text={'Accept'} />
      </FooterFlex>
    )
  }
  return (
  
      <StyledDrawer
        width="600px"
        title={'Offer Detail'}
        placement="right"
        closable={true}
        onClose={() => setDrawer(false)}
        visible={drawer}
        content={content()}
        footer={footer()}
      />
  
  )
}

export default OfferDetailDrawer
